export default __webpack_public_path__ + "static/media/isnurance.12d83126.svg";